<template>
  <div class="faq-images">
    <div class="faq-image faq-image-large">
      <img
        :src="images[0]?.src"
        :alt="images[0]?.alt"
        width="300"
        height="400"
        loading="lazy"
        decoding="async"
      >
    </div>
    <div class="faq-image faq-image-small-top">
      <img
        :src="images[1]?.src"
        :alt="images[1]?.alt"
        width="300"
        height="300"
        loading="lazy"
        decoding="async"
      >
    </div>
    <div class="faq-image faq-image-small-bottom">
      <img
        :src="images[2]?.src"
        :alt="images[2]?.alt"
        width="300"
        height="300"
        loading="lazy"
        decoding="async"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
const images = [
  {
    src: '/assets/images/index/faq/faq-large.jpg',
    alt: 'Експерт'
  },
  {
    src: '/assets/images/index/faq/faq-small-top.jpg',
    alt: 'Експерт'
  },
  {
    src: '/assets/images/index/faq/faq-small-bottom.jpg',
    alt: 'Експерт'
  }
]
</script>

<style scoped>
.faq-images {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: 1fr 1fr;
  gap: 24px;
  align-content: start;
  width: 100%;
  max-width: 630px;
  height: auto;
  aspect-ratio: 630 / 625;
  transform-origin: top left;
}

.faq-image {
  border-radius: 8px;
  overflow: hidden;
  min-width: 0;
}

.faq-image-large {
  grid-column: 1;
  grid-row: 1 / -1;
  height: 100%;
  position: relative;
  top: -40px;
}

.faq-image-small-top {
  grid-column: 2;
  grid-row: 1;
  aspect-ratio: 1 / 1;
}

.faq-image-small-bottom {
  grid-column: 2;
  grid-row: 2;
  aspect-ratio: 1 / 1;
}

.faq-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 1200px) {
  .faq-images {
    max-width: 500px;
  }
}

@media (max-width: 991px) {
  .faq-images {
    display: none;
  }
}

@media (max-width: 1100px) {
  .faq-image-large {
    top: 0;
  }
}
</style>

